<template>
    <div class="mb-4">
        <BaseCallout
            type="primary"
            small
            style="max-width: 750px;"
            icon="info-circle"
            :title="$t(changeWordingRegistrationBuy ? 'eventRegistration.summary.reviewTitleBuy' : 'eventRegistration.summary.reviewTitle')"
            :message="$t(changeWordingRegistrationBuy ? 'eventRegistration.summary.reviewExplanationBuy' : 'eventRegistration.summary.reviewExplanation')" />
    </div>
</template>

<script>
import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";

export default {
    name: "Review",
    mixins: [mainRegistrationMixin],
}
</script>

<style lang="scss" scoped>
</style>
